import React from "react";
import { useInfiniteQuery } from "react-query";
import { fetchLimitedData } from "../api";
import BookRecommendationElement from "../components/Recommendation/BookRecommandation";
import SEO from "../components/SEO/SEO";
import LoadingButton from "../components/LoadingButton/LoadingButton";

function BookRecommendation() {
  const limit = 2;

  // Infinite Query für Bücher
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      ["book"],
      async ({ pageParam = 0 }) => {
        return fetchLimitedData("book", pageParam, limit);
      },
      {
        getNextPageParam: (lastPage, allPages) => {
          if (lastPage.length < limit) return undefined;
          return allPages.length; // page number
        },
      }
    );

  // Alle Seiten zusammenführen
  const allItems = data?.pages.flat() || [];

  return (
    <>
      <SEO
        title="Bücher"
        keywords="Bücher"
        description="Buchempfehlungen"
        type="Bücher"
        url={window.location.href}
      />
      <h1 className="text-light text-center">Bücher</h1>
      <br />
      {allItems.length > 0 &&
        allItems.map((el, index) => (
          <BookRecommendationElement
            key={index}
            author={el?.author}
            cover={el?.cover}
            summary={el?.summary}
            title={el?.name}
            link={el?.link}
          />
        ))}

      {hasNextPage && (
        <div className="text-center mt-6">
          <LoadingButton
            onClick={() => fetchNextPage()}
            loading={isFetchingNextPage}
          />
        </div>
      )}
    </>
  );
}

export default BookRecommendation;
